Vue.component('search-terms', {
  props: ['tryb', 'skrot', 'skrot2', 'room', 'adults', 'children', 'age_child_1', 'age_child_2', 'age_child_3', 'age_child_4', 'btnClass'],
  template: '#vue-search-terms',
  data: function () {
    return {
      elementHandle: 'terms_' + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15),
      termsLoaded: false,
    }
  },
  created: function () {
    // console.log('search-terms [created]');
  },
  methods: {
    showTermsTable: function (el) {
      this.termsLoaded = true;
      colorboxInlineHTML($(el));

      const self = this;
      $(document.body).one("click", '#cboxClose', function () {
        self.termsLoaded = false;
      });
    }
  }
});

Vue.component('search-terms-table', {
  props: ['tryb', 'skrot', 'skrot2', 'room', 'adults', 'children', 'age_child_1', 'age_child_2', 'age_child_3', 'age_child_4'],
  template: '#vue-search-terms-table',
  data: function () {
    return {
      loaded: false,
      agent: '',
      touroperator: '',
      mw: 'default',
      showMw: true,
      mwOptions: [],
      alimentation: 'default',
      alimentationOptions: [],
      day: 'default',
      dayOptions: [],
      terms: [],
      panels: [],
      allTerms: [],
      activePanel: '',
      pageSize: 20,
      pageNumber: 0
    }
  },
  created: function () {
    if (this.setParamsFromSearchState() === false) {
      this.getTerms(this.tryb, this.skrot, this.skrot2, this.room, this.mw, this.alimentation, this.day);
    }
  },
  watch: {
    skrot: function (newSkrot, oldSkrot) {
      if (newSkrot != oldSkrot) {
        this.allTerms = this.getTerms(this.tryb, newSkrot, this.skrot2, this.room, this.mw, this.alimentation, this.day);
      }
    },
    mw: function (newMw, oldMw) {
      if (newMw != oldMw) {
        this.allTerms = this.getTerms(this.tryb, this.skrot, this.skrot2, this.room, newMw, this.alimentation, this.day);
      }
    },
    alimentation: function (newAlimentation, oldAlimentation) {
      if (newAlimentation != oldAlimentation) {
        this.allTerms = this.getTerms(this.tryb, this.skrot, this.skrot2, this.room, this.mw, newAlimentation, this.day);
      }
    },
    day: function (newDay, oldDay) {
      if (newDay != oldDay) {
        this.allTerms = this.getTerms(this.tryb, this.skrot, this.skrot2, this.room, this.mw, this.alimentation, newDay);
      }
    },
    panels: function (newPanels, oldPanels) {
      if (newPanels != oldPanels) {
        this.changeDataInPanel(newPanels[0]);
      }
    },
    pageNumber: function (newPageNumber, oldPageNumber) {
      if (newPageNumber != oldPageNumber) {
        const element = document.getElementById("panels");
        window.scrollTo(0, element.offsetTop);
      }
    }
  },
  methods: {
    setParamsFromSearchState: function () {
      let flag = false;
      if (this.mw == 'default' && typeof store.state.searchParams.mw !== 'undefined' && store.state.searchParams.mw != 'default') {
        this.mw = store.state.searchParams.mw;
        flag = true;
      }
      if (this.alimentation == 'default' && typeof store.state.searchParams.alimentation !== 'undefined' && store.state.searchParams.alimentation != 'default') {
        this.alimentation = store.state.searchParams.alimentation;
        flag = true;
      }
      return flag;
    },
    getTerms: function (tryb, skrot, skrot2, room, mw, alimentation, day) {
      const self = this;
      self.loaded = false;
      $.post("/back/search/SearchTerms.php", { tryb: tryb, skrot: skrot, skrot2: skrot2, room: room, mw: mw, alimentation: alimentation, day: day }, function (result, textStatus) {
        self.agent = result.config.agent;
        self.touroperator = result.config.touroperator;
        self.showMw = result.config.showMw;
        self.panels = result.groups;
        self.allTerms = result.allTerms;
        self.mwOptions = result.mw;
        self.alimentationOptions = result.alimentation;
        self.dayOptions = result.days;
        self.loaded = true;
      }, "json");
    },
    changeDataInPanel: function (panel) {
      this.setPage(0);
      this.terms = this.allTerms[panel];
      this.activePanel = panel;
    },
    getPage: function () {
      return this.pageNumber;
    },
    setPage: function (pageNumber) {
      this.pageNumber = pageNumber;
    },
    nextPage: function () {
      if (this.pageNumber < this.pageCount() - 1) {
        this.pageNumber++;
      }
    },
    prevPage: function () {
      if (this.pageNumber > 0) {
        this.pageNumber--;
      }
    },
    pageCount: function () {
      return Math.floor(this.terms.length / this.pageSize) + 1;
    },
    paginatedIndex: function () {
      let index = [];
      for (let i = 0, len = this.pageCount(); i < len; i++) {
        index[i] = i + 1;
      }
      return index;
    },
    paginatedData: function () {
      const start = this.pageNumber * this.pageSize;
      const end = start + this.pageSize;
      return this.terms.slice(start, end);
    },
    getPopUpLink: function (term) {
      // Create href for "Rezerwuj" button
      const self = this;
      let skrot = encodeURIComponent(term.skrot);
      let skrot2 = encodeURIComponent(self.skrot2);
      let roomtype = encodeURIComponent(self.room.replaceAll("|", "/"));

      let href = "";
      if (self.agent == "kompas2www" || self.agent == "kompasoasis2www") {
        href = "//wwwgen.sykon.pl/afiliacjaariadna/agx/" + this.agent + "/index.php?onepage=20&adults=" + this.adults + "&child1=" + this.age_child_1 + "&child2=" + this.age_child_2 + "&child3=" + this.age_child_3 + "&child4=" + this.age_child_4 + "&md=" + skrot + "|" + term.departureDate + "|" + term.arrivalDate + "&r_opt=1";
        // } else if (self.agent == "aturnew2www") {
        //     href = "//wwwgen.sykon.pl/afiliacjaariadna1B/agx/" + this.agent + "/index.php?onepage=20&adults=" + this.adults + "&child1=" + this.age_child_1 + "&child2=" + this.age_child_2 + "&child3=" + this.age_child_3 + "&child4=" + this.age_child_4 + "&md=" + skrot + "|" + term.departureDate + "|" + term.arrivalDate + "|" + term.fullDeparturePlace + "|" + term.arrivalPlace + "&r_opt=1";
      } else if (["lulubeds2www", "puntanatura2www", "aturnew2www", "nflight2www"].includes(self.agentx)) {
        href = "//wwwgen.sykon.pl/afiliacjaariadna1B/agx/" + this.agent + "/index.php?szukaj=szukaj_wycieczki&adults=" + this.adults + "&top=" + this.touroperator + "&rewrite=on&tourop=agx&agentx=" + this.agent + "&onepage=20&from=" + term.departureDateYmd + "&to=" + term.arrivalDateYmd + "&tourop_hotel=" + this.touroperator + "|" + skrot2 + "&roomtype=" + roomtype + "&md=get_md_value";
      } else {
        href = "//wwwgen.sykon.pl/afiliacjaariadna1B/agx/" + this.agent + "/index.php?szukaj=szukaj_wycieczki&adults=" + this.adults + "&top=" + this.touroperator + "&rewrite=on&tourop=agx&agentx=" + this.agent + "&onepage=20&from=" + term.departureDateYmd + "&to=" + term.arrivalDateYmd + "&tourop_hotel=" + this.touroperator + "|" + skrot + "&md=get_md_value";
      }
      return href;
    }
  }
});